// @flow

var conversionTable = {
  "440": "2 Furlongs",
  "550": "2 1/2 Furlongs",
  "660": "3 Furlongs",
  "770": "3 1/2 Furlongs",
  "880": "4 Furlongs",
  "990": "4 1/2 Furlongs",
  "1100": "5 Furlongs",
  "1210": "5 1/2 Furlongs",
  "1320": "6 Furlongs",
  "1430": "6 1/2 Furlongs",
  "1540": "7 Furlongs",
  "1650": "7 1/2 Furlongs",
  "1760": "1 Mile",
  "1800": "1 Mile 40 Yards",
  "1830": "1 Mile 70 Yards",
  "1870": "1 1/16 Miles",
  "1980": "1 1/8 Miles",
  "2090": "1 3/16 Miles",
  "2200": "1 1/4 Miles",
  "2310": "1 5/16 Miles",
  "2420": "1 3/8 Miles",
  "2530": "1 7/16 Miles",
  "2640": "1 1/2 Miles",
  "2750": "1 9/16 Miles",
  "2860": "1 5/8 Miles",
  "2970": "1 11/16 Miles",
  "3080": "1 3/4 Miles",
  "3190": "1 13/16 Miles",
  "3300": "1 7/8 Miles",
  "3410": "1 15/16 Miles",
  "3520": "2 Miles",
  "3630": "2 1/16 Miles",
  "3740": "2 1/8 Miles",
  "3850": "2 3/16 Miles",
  "3960": "2 1/4 Miles",
  "4400": "2 1/2 Miles"
};

export default function(yards: string) {
  var val = conversionTable[yards.toString()];
  if (val) {
    return val;
  }
  if (!containsNonNumericCharacters(yards)) {
    return yards + " Yards";
  }
  return yards;
}

function containsNonNumericCharacters(str) {
  return str.replace(/[\d\s]/g, "").length > 0;
}
